<template>
    <AppLayout :has-background="true" :contained="true">
        <div class="elevation-3 p-4 bg-white rounded">
            <v-card-title>
                <font-awesome-icon icon="fa-regular fa-book-open-cover" style="margin-right: 0.5rem" />
                <h3 class="m-0">Guest Book</h3>
            </v-card-title>

            <div class="d-flex" style="gap: 44px">
                <Calendar
                    clearable
                    v-model="startDate"
                    label="From:"
                    style="width: 200px"
                    :output-local="true"
                ></Calendar>
                <Calendar clearable v-model="endDate" label="To:" style="width: 200px" :output-local="true"></Calendar>

                <v-spacer></v-spacer>
                <v-text-field
                    append-icon="mdi-magnify"
                    label="Search"
                    style="max-width: 300px"
                    v-model="search"
                ></v-text-field>
            </div>

            <GuestbookTable
                v-if="mode"
                :mode="mode"
                :search="search"
                :start="startDate"
                :end="endDate"
            ></GuestbookTable>
        </div>
    </AppLayout>
</template>
<script>
import GuestbookTable from '@/components/Tables/GuestbookTable.vue';
import Calendar from '@/components/ui/Calendar.vue';
export default {
    components: { GuestbookTable, Calendar },
    data() {
        return {
            search: '',
            startDate: null,
            endDate: null,
        };
    },
    computed: {
        mode() {
            if (this?.$auth?.role?.includes('Owner' || 'RegionalManager')) return 'owner';

            if (this?.$auth?.role?.includes('SuperAdmin')) return 'admin';

            return null;
        },
    },
};
</script>
<style lang=""></style>
